export default __webpack_public_path__ + "static/media/servicetype_pcb_192.63821625.png";